module.exports = __webpack_public_path__ + "static/media/flag-group.c81cc199.png";